"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ThreadHeader;
var _react = _interopRequireWildcard(require("react"));
var _AssistantProvider = require("./AssistantProvider");
var _constants = require("./constants");
var _logo = _interopRequireDefault(require("./assets/logo.svg"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function Tip(_ref) {
  let {
    label,
    children
  } = _ref;
  return (0, _jsxRuntime.jsxs)("span", {
    className: "tw-relative tw-inline-flex tw-group",
    children: [children, (0, _jsxRuntime.jsx)("span", {
      className: "tw-pointer-events-none tw-absolute tw-top-full tw-left-1/2 tw--translate-x-1/2 tw-mt-1.5 tw-whitespace-nowrap tw-rounded tw-bg-gray-800 tw-text-white tw-text-[11px] tw-px-2 tw-py-1 tw-opacity-0 tw-scale-95 group-hover:tw-opacity-100 group-hover:tw-scale-100 tw-transition tw-duration-100 tw-z-50",
      role: "tooltip",
      children: label
    })]
  });
}
function ThreadHeader(_ref2) {
  let {
    mode = 'sidebar',
    onClose
  } = _ref2;
  const {
    startNewThread,
    resetPath,
    openFeedback,
    sidebarWidth,
    setSidebarWidth
  } = (0, _AssistantProvider.useAssistant)();
  const [isFullScreen, setIsFullScreen] = (0, _react.useState)(false);
  const prevWidthRef = (0, _react.useRef)(null);
  const iconBtnStyle = {
    background: 'transparent',
    border: 'none',
    cursor: 'pointer',
    color: 'rgba(255,255,255,0.8)',
    padding: '6px',
    borderRadius: '6px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'background 0.15s, color 0.15s'
  };
  const toggleFullScreen = () => {
    if (isFullScreen) {
      setSidebarWidth(_constants.SIDEBAR.DEFAULT_WIDTH);
      setIsFullScreen(false);
    } else {
      prevWidthRef.current = sidebarWidth;
      setSidebarWidth(window.innerWidth);
      setIsFullScreen(true);
    }
  };
  const sidebarHeaderStyle = {
    width: '100%',
    padding: '10px 16px',
    background: 'linear-gradient(90deg, #1976d2 0%, #8e24aa 100%)',
    color: '#fff',
    fontWeight: 600,
    fontSize: '1.15rem',
    letterSpacing: '0.01em',
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
    borderBottom: '1.5px solid #e6e6e6',
    position: 'sticky',
    top: 0,
    zIndex: 100,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexShrink: 0,
    boxSizing: 'border-box',
    fontFamily: 'var(--sa-font, "Graphik UHG", Arial, sans-serif)'
  };
  const standaloneHeaderStyle = {
    width: '100%',
    padding: '18px 32px',
    background: 'linear-gradient(90deg, #1976d2 0%, #8e24aa 100%)',
    color: '#fff',
    fontWeight: 600,
    fontSize: '1.2rem',
    letterSpacing: '-0.01em',
    borderRadius: 0,
    boxShadow: '0 2px 12px rgba(0,0,0,0.06)',
    borderBottom: 'none',
    position: 'sticky',
    top: 0,
    zIndex: 100,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexShrink: 0,
    boxSizing: 'border-box',
    fontFamily: '"Inter", "Segoe UI", system-ui, -apple-system, sans-serif'
  };
  const headerStyle = mode === 'standalone' || isFullScreen ? standaloneHeaderStyle : sidebarHeaderStyle;
  return (0, _jsxRuntime.jsxs)("header", {
    style: headerStyle,
    children: [(0, _jsxRuntime.jsx)("div", {
      style: {
        display: 'flex',
        alignItems: 'center'
      },
      children: (0, _jsxRuntime.jsx)(Tip, {
        label: "Start a new conversation",
        children: (0, _jsxRuntime.jsx)("button", {
          style: iconBtnStyle,
          onMouseEnter: e => {
            e.currentTarget.style.background = 'rgba(255,255,255,0.15)';
            e.currentTarget.style.color = '#fff';
          },
          onMouseLeave: e => {
            e.currentTarget.style.background = 'transparent';
            e.currentTarget.style.color = 'rgba(255,255,255,0.8)';
          },
          onClick: () => {
            resetPath();
            startNewThread();
          },
          "aria-label": "Start a new conversation",
          children: (0, _jsxRuntime.jsxs)("svg", {
            width: "18",
            height: "18",
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            children: [(0, _jsxRuntime.jsx)("path", {
              d: "M12 20h9"
            }), (0, _jsxRuntime.jsx)("path", {
              d: "M16.5 3.5a2.12 2.12 0 013 3L7 19l-4 1 1-4z"
            })]
          })
        })
      })
    }), (0, _jsxRuntime.jsxs)("span", {
      style: {
        position: 'absolute',
        left: '50%',
        transform: 'translateX(-50%)',
        whiteSpace: 'nowrap',
        fontWeight: 700,
        fontSize: '1.15rem',
        letterSpacing: '0.02em',
        display: 'flex',
        alignItems: 'center',
        gap: '8px'
      },
      children: [(mode === 'standalone' || isFullScreen) && (0, _jsxRuntime.jsx)("img", {
        src: _logo.default,
        alt: "Optum",
        style: {
          width: '26px',
          height: '26px',
          objectFit: 'contain',
          filter: 'brightness(0) invert(1)',
          opacity: 0.9
        }
      }), "EIMP SmartAssist"]
    }), (0, _jsxRuntime.jsxs)("div", {
      style: {
        display: 'flex',
        alignItems: 'center',
        gap: '4px'
      },
      children: [(0, _jsxRuntime.jsx)(Tip, {
        label: "Share your feedback",
        children: (0, _jsxRuntime.jsx)("button", {
          style: iconBtnStyle,
          onMouseEnter: e => {
            e.currentTarget.style.background = 'rgba(255,255,255,0.15)';
            e.currentTarget.style.color = '#fff';
          },
          onMouseLeave: e => {
            e.currentTarget.style.background = 'transparent';
            e.currentTarget.style.color = 'rgba(255,255,255,0.8)';
          },
          onClick: () => openFeedback(),
          "aria-label": "Share your feedback",
          children: (0, _jsxRuntime.jsx)("svg", {
            width: "16",
            height: "16",
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            children: (0, _jsxRuntime.jsx)("polygon", {
              points: "12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"
            })
          })
        })
      }), mode === 'sidebar' && (0, _jsxRuntime.jsx)(Tip, {
        label: isFullScreen ? 'Exit full screen' : 'Full screen',
        children: (0, _jsxRuntime.jsx)("button", {
          style: iconBtnStyle,
          onMouseEnter: e => {
            e.currentTarget.style.background = 'rgba(255,255,255,0.15)';
            e.currentTarget.style.color = '#fff';
          },
          onMouseLeave: e => {
            e.currentTarget.style.background = 'transparent';
            e.currentTarget.style.color = 'rgba(255,255,255,0.8)';
          },
          onClick: toggleFullScreen,
          "aria-label": isFullScreen ? 'Exit full screen' : 'Full screen',
          children: isFullScreen ? (0, _jsxRuntime.jsxs)("svg", {
            width: "16",
            height: "16",
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            children: [(0, _jsxRuntime.jsx)("path", {
              d: "M8 3v3a2 2 0 01-2 2H3"
            }), (0, _jsxRuntime.jsx)("path", {
              d: "M21 8h-3a2 2 0 01-2-2V3"
            }), (0, _jsxRuntime.jsx)("path", {
              d: "M3 16h3a2 2 0 012 2v3"
            }), (0, _jsxRuntime.jsx)("path", {
              d: "M16 21v-3a2 2 0 012-2h3"
            })]
          }) : (0, _jsxRuntime.jsxs)("svg", {
            width: "16",
            height: "16",
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            children: [(0, _jsxRuntime.jsx)("path", {
              d: "M8 3H5a2 2 0 00-2 2v3"
            }), (0, _jsxRuntime.jsx)("path", {
              d: "M21 8V5a2 2 0 00-2-2h-3"
            }), (0, _jsxRuntime.jsx)("path", {
              d: "M3 16v3a2 2 0 002 2h3"
            }), (0, _jsxRuntime.jsx)("path", {
              d: "M16 21h3a2 2 0 002-2v-3"
            })]
          })
        })
      }), mode === 'sidebar' && onClose && (0, _jsxRuntime.jsx)(Tip, {
        label: "Close",
        children: (0, _jsxRuntime.jsx)("button", {
          style: iconBtnStyle,
          onMouseEnter: e => {
            e.currentTarget.style.background = 'rgba(255,255,255,0.15)';
            e.currentTarget.style.color = '#fff';
          },
          onMouseLeave: e => {
            e.currentTarget.style.background = 'transparent';
            e.currentTarget.style.color = 'rgba(255,255,255,0.8)';
          },
          onClick: onClose,
          "aria-label": "Close sidebar",
          children: (0, _jsxRuntime.jsxs)("svg", {
            width: "16",
            height: "16",
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            children: [(0, _jsxRuntime.jsx)("line", {
              x1: "18",
              y1: "6",
              x2: "6",
              y2: "18"
            }), (0, _jsxRuntime.jsx)("line", {
              x1: "6",
              y1: "6",
              x2: "18",
              y2: "18"
            })]
          })
        })
      })]
    })]
  });
}